import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    root: {
      padding: spacing(3),
    },
  });
